import _ from 'lodash'
import Vue from 'vue'
import Router from 'vue-router'
import routers from './routers'
import async from './async'
import store from '../store'
import Cookies from 'js-cookie'
import UserService from '@/request/user/user'
import PermissionUtils from '@/utils/permission'

Vue.use(Router)

store.dispatch('routers', routers)
const router = new Router({
    routes: routers
})

router.beforeEach((to, from, next) => {
    let access_token = store.state.tokens.access_token
    let refresh_token = store.state.tokens.refresh_token
    if (!access_token) {
        if (Cookies.get('user_token')) {
            access_token = Cookies.get('user_token')
        }
        if (access_token) {
            store.dispatch('tokens', {
                access_token: access_token
            })
        }
    }
    if (!refresh_token) {
        refresh_token = Cookies.get('refresh_token')
        if (refresh_token) {
            store.dispatch('tokens', {
                refresh_token: refresh_token
            })
        }
    }
    if (!access_token) {
        location.href = process.env['VUE_APP_LOGIN_URL'] + '?redirect=' + encodeURI(location.href)
    }
    if (!store.state.user) {
        UserService.current().then(res => {
            store.dispatch('user', res.result).then(() => {
                let addRouters = PermissionUtils.hasPermissionRouter(async, store.getters.permissions, !_.isEmpty(store.getters.hospitals))
                router.addRoutes(addRouters)
                let rs = _.orderBy(_.concat(routers, addRouters), ['index'])
                store.dispatch('routers', rs)
                next({ ...to, replace: true })
                // if (PermissionUtils.hasPermission('per_opration_001003|per_opration_001004|per_opration_001005', store.getters.permissions) && !from.name) {
                //   next('/operation')
                // } else {
                //   next({ ...to, replace: true })
                // }
            })
        }).catch(() => {
            location.href = process.env['VUE_APP_LOGIN_URL'] + '?redirect=' + encodeURI(location.href)
        })
    } else {
        next()
    }
})

export default router
